export default {
  home: {
    sections: {
      trendingToday: "Trending today",
      offers: "Offers",
      partners: "Partners",
      cheatsheets: "Cheatsheets",
      predictionMarkets: "Prediction Markets",
      advancedTools: "Advanced Tools",
      parlays: "Parlays",
      upcomingGames: "Upcoming games",
    },
    offers: {
      types: {
        FANTASY_FREE_PICK: "Daily picks",
        BOOST: "Boosts",
        SPORTSBOOK_SIGNUP: "Sportsbook",
        FANTASY_SIGNUP: "Fantasy",
        PREDICTION_SIGNUP: "Prediction",
        SWEEPSTAKES_SIGNUP: "Sweepstakes",
        CASINO_SIGNUP: "Casino",
        PARTNER: "Partners",
      },
    },
    offseason: {
      eyebrow: "Offseason",
      body: "See you soon for the new season!",
    },
    seasonChampion: {
      description: "{{team}} are the {{championship}}.",
      descriptionWithArticle: "The {{team}} are the {{championship}}.",
      descriptions: {
        default: "{{league}} Champions",
        superbowl: "Superbowl Champions",
        stanleyCup: "Stanley Cup Champions",
        premierLeague: "Premier League Champions",
        worldSeries: "World Series Champions",
        european: "European Champions",
        europaLeague: "Europa League Champions",
        ncaaBasketball: "NCAA Basketball Champions",
        ncaaFootball: "NCAA Football Champions",
      },
    },
    noGamesToday: "There are no games today in the {{league}}.",
    currentlyInOffseason: "Currently in offseason.",
    featured: {
      gameOfDay: "Game of the Day",
      gameOfWeek: "Game of the Week",
      parlayTrends: "Parlay Trends",
      cheatsheets: "Cheatsheets",
      unlockRewardTitle: "Unlock your reward",
      unlockRewardSubtitle: "Claim premium access to see more.",
      unlockRewardBody: "Get access to more trends, tools, and insights.",
    },
    cards: {
      placeItOn: "Place it on",
      advancedToolsCta: "Join Linemate+",
      premiumBlurb: "Unlock the full experience. Go deeper on every trend.",
    },
    empty: {
      trend: "No trends available. Please check back later.",
      cheatsheet: "No cheatsheets available. Please check back later.",
      offer: "No offers available. Please check back later.",
    },
    cheatsheets: {
      recentForm: "Recent Form",
      versusOpponent: "Versus Opponent",
      alternateLines: "Alternate Lines",
      firstQuarter: "1st Quarter",
      firstHalf: "1st Half",
      homeAwayGames: "Home/Away Games",
      teamForm: "Team Form",
      undersOnly: "Unders Only",
    },
    tools: {
      props: "Props",
      markets: "Markets",
      cheatsheets: "Cheatsheets",
      generateParlay: "Parlay Builder",
      lineups: "Lineups",
      injuries: "Injuries",
      rank: "Rank",
      weather: "Weather",
      pitchers: "Pitchers",
      stats: "Stats",
      standings: "Standings",
    },
    generateParlay: {
      parlayType: {
        subtitle: "Use recent form, matchup history, or home/away performance.",
        recentFormDescription: "Performance over the last 20 games",
        versusOpponentDescription: "Last 20 games vs this opponent",
        homeAwaySplitsDescription: "Last 20 games at home or away",
      },
      legs: {
        title: "How many legs do you want?",
        subtitle: "Choose how big of a parlay you want to generate",
        label: "{{count}} Legs",
      },
      participants: {
        title: "Who should be included?",
        subtitle: "Choose which team(s) or player(s) you want in your parlay",
        searchPlayer: "Search for a player",
        searchTeam: "Search for a team",
        allPlayers: "All Players",
        allTeams: "All Teams",
      },
      result: {name: "Parlay", title: "Your Parlay"},
      empty: {
        title: "No parlay found",
        subtitle: "Try changing your selections to generate a parlay.",
      },
      actions: {goHome: "Go back to Home", share: "Share parlay"},
      loader: {
        ready: "Parlay ready",
        accessibilityLabel: "Generating your Parlay",
        values: {
          legs: "{{count}} Legs...",
          allGames: "All Games...",
          selectedGames: "{{count}} Games...",
          allPlayers: "All Players...",
          allTeams: "All Teams...",
          selectedParticipants: "{{count}} Participants...",
          selectedBetTypes: "{{count}} Bet Types...",
          selectedSportsbooks: "{{count}} Sportsbooks...",
          building: "Building your Parlay...",
        },
      },
    },
    predictionMarkets: {
      hubTitle: "Prediction Market Hub",
      values: {
        points: "{{count}} pts",
        trades: "{{count}} Trades",
      },
      analysis: {
        title: "Market Analysis",
        allExchanges: "All Exchanges",
        perExchange: "Per Exchange",
        chips: {
          all: "All",
          oneDay: "1-Day",
          oneWeek: "1-Week",
        },
        rows: {
          volume: "Volume",
          movement: "Movement",
          marketSplit: "Market Split",
          largestTrade: "Largest Trade",
          activity: "Activity",
        },
      },
      cards: {
        mostVolume: {
          title: "Most Volume",
          description: "Markets with the most money traded",
        },
        largestTrades: {
          title: "Largest Trades",
          description: "Markets with the biggest individual trades",
        },
        biggestMovers: {
          title: "Biggest Movers",
          description: "Markets with the largest probability changes",
        },
        marketsSplit: {
          title: "Markets Split",
          description: "Markets with the biggest differences across platforms",
        },
        mostActivity: {
          title: "Most Activity",
          description: "Markets with the highest number of trades",
        },
      },
      previews: {
        superBowlWinner: "Super Bowl winner",
        nbaChampions: "NBA champions",
        worldSeriesWinner: "World Series winner",
        easternConference: "Eastern conference",
        westernConference: "Western conference",
        nfcWinner: "NFC winner",
        afcChampions: "AFC champions",
        alPennant: "AL pennant",
        stanleyCup: "Stanley Cup",
        afcEast: "AFC East",
        afcNorth: "AFC North",
        nfcNorth: "NFC North",
        nfcWest: "NFC West",
        nlCentral: "NL Central",
        nlWest: "NL West",
        premierLeague: "Premier League",
        divisionWinner: "Division winner",
      },
    },
    advancedTools: {
      marketAgainst: "{{market}} against",
      vsOpponent: "vs {{opponent}}",
    },
    sponsoredBy: "Sponsored by {{operator}}",
  },
};
